module.exports = __webpack_public_path__ + "static/media/aquatics.74e56ef2.svg";